// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Carousel_carousel__2AWtj","carousel-inner":"Carousel_carousel-inner__1Ze06"};